import {
  INVITE_TO_PERSONA,
  ADVISOR_REALTOR,
  ADVISOR_LOANOFFICER,
  ADVISOR_ATTORNEY,
  ADVISOR_INSPECTOR,
  ADVISOR_INSURANCE,
  ADVISOR_ACCOUNTANT,
  ADVISOR_MOVER,
  TITLE_AGENCY,
  APPRAISER,
  UNDER_WRITER,
  LOAN_PROCESSOR,
  COBORROWER,
  BORROWER,
  ADVISOR_ISO,
  SMARTMATCH_TYPE_COBORROWER,
  SMARTMATCH_TYPE_BORROWER,
  SMARTMATCH_TYPE_REALTOR,
  SMARTMATCH_TYPE_TAX_ATTORNEY,
  SMARTMATCH_TYPE_TAX_ACCOUNTANT,
  SMARTMATCH_TYPE_HOME_INSURANCE,
  SMARTMATCH_TYPE_HOME_INSPECTOR,
  SMARTMATCH_TYPE_LOAN_OFFICER,
  SMARTMATCH_TYPE_MOVER,
  SMARTMATCH_TYPE_TITLE_AGENCY,
  SMARTMATCH_TYPE_UNDER_WRITER,
  SMARTMATCH_TYPE_APPRAISER,
  SMARTMATCH_TYPE_LOAN_PROCESSOR,
  SMARTMATCH_TYPE_FUNDING_SPECIALIST,
  SMARTMATCH_TYPE_ISO,
  SMARTMATCH_TYPE_ADMIN_ISO,
  LO_100_PERCENT_MATCHED,
  APPLICANT_DOWNCASE_A,
  APPLICANT,
  DEEDSY_SH_DISPLAY_LOCATION,
  DEEDSY_SH_BUSINESS_LOCATION,
  ADVISOR_FUNDING_SPECIAILIST,
  META_DATA,
  MERCHANT_CASH_ADVANCE,
  SMARTMATCH_TYPE_BACKEND_OFFICER,
  SMARTMATCH_TYPE_ACCOUNTING,
  SMARTMATCH_TYPE_SALES,
  ADVISOR_ACCOUNTING,
  ADVISOR_SALES,
  BACKEND_OFFICER,
  ADMIN_UNDER_WRITER,
  SMARTMATCH_TYPE_ADMIN,
  ADVISOR_SUPER_ADMIN,
  ADVISOR_HIGH_CEREST,
  SMARTMATCH_TYPE_HIGH_CREST,
  SMARTMATCH_TYPE_LOAN_PROCESSOR_READER,
  LOAN_PROCESSOR_READER,
  ADMIN_LOANOFFICER,
  ADVISOR_ADMINISO,
  LOAN_OFFICER_BACKEND,
  SMARTMATCH_TYPE_SALES_ADMIN,
  ADVISOR_ADMINSALES,
  ADVISOR_REVIEWER_ADMIN,
  LOAN_OFFICER_CARDS,
  LOAN_OFFICER_MORTGAGE,
  LOAN_OFFICER_CONSUMER,
  PRODUCT_ADMIN,
  LOAN_OFFICER_CARDS_SECURED,
} from 'src/services/constants';
import {
  equals,
  pathOr,
  filter,
  toLower,
  ifElse,
  isEmpty,
  always,
  isNil,
  cond,
  T,
  replace,
  head,
  splitAt,
  split,
  join,
  last,
  flatten,
  nth,
} from 'ramda';
import { LD, mapIndexed } from 'src/utilities/visualFieldsMapper';
import {
  USER_ONBOARD_ADMIN_LO,
  USER_ONBOARD_ADMIN_READER,
  USER_ONBOARD_ADMIN_UNDERWRITER,
  USER_ONBOARD_LOAN_OFFICER_BACK_END,
  USER_ONBOARD_LOAN_OFFICER_CARDS,
  USER_ONBOARD_LOAN_OFFICER_MORTGAGE,
  USER_ONBOARD_LOAN_OFFICER_CONSUMER,
  USER_ONBOARD_ADMIN_PRODUCTS,
  USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED
} from 'src/services/constants/accounts';
import { pruneToAddress } from 'src/utilities/properties';
import { isNotEmpty, returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';
import { getFullName } from './naming';
import { capitalizeAllWords } from './capitalize';


export const mapAdvisors = (response: any) => {
  return mapIndexed((oneAdvisor: any, index: any) => {
    const sourceId = ifElse(
      isEmpty || equals('0'),
      always(index),
      always(pathOr('', ['source_id'], oneAdvisor))
    )(pathOr('', ['source_id'], oneAdvisor));
    const fullName = getFullName(oneAdvisor);
    const address = ifElse(
      isNotEmpty,
      always(pathOr('', [META_DATA, DEEDSY_SH_DISPLAY_LOCATION], oneAdvisor)),
      always(pathOr('', [META_DATA, DEEDSY_SH_BUSINESS_LOCATION], oneAdvisor))
    )(pathOr('', [META_DATA, DEEDSY_SH_DISPLAY_LOCATION], oneAdvisor));
    return LD(
      oneAdvisor,
      LO_MAPPED_FIELDS(sourceId, fullName, pruneToAddress(address))
    );
  }, pathOr([], ['items'], response));
};

const LO_MAPPED_FIELDS = (sourceId: string, fullName: string, address: any) => {
  return [
    { from: ['id'], to: ['advisor_id'] },
    { from: ['source_id'], to: ['id'], ov: sourceId },
    { from: ['email'], to: ['basic', 'email'] },
    { from: ['first_name'], to: ['basic', 'name'], ov: fullName },
    { from: ['metadata'], to: ['metadata'] },
    {
      from: ['address', 'city'],
      to: ['basic', 'city'],
      ov: pathOr('', ['city'], address),
    },
    {
      from: ['address', 'state'],
      to: ['basic', 'state'],
      ov: pathOr('', ['state'], address),
    },
    {
      from: ['address', 'country'],
      to: ['basic', 'country'],
      ov: pathOr('', ['country'], address),
    },
    { from: ['avatar'], to: ['basic', 'image'] },
    { from: ['license'], to: ['basic', 'license'] },
    { from: ['business_name'], to: ['basic', 'business_name'] },
    {
      from: ['ratings'],
      to: ['ratings', 'rating'],
      ov: LO_100_PERCENT_MATCHED,
    },
    { from: ['nmls_id'], to: ['advanced', 'nmls_id'] },
    { from: ['business_email'], to: ['advanced', 'business_email'] },
    { from: ['persona'], to: ['basic', 'persona'] },
  ];
};
// Attempt to
// 1. Load the persona from advisor_profile
// 2. If not available from metadata invite_to_persona
export const getMemberPersona = (teamMember: any) => {
  return (
    pathOr('', ['spec', 'advisor_profile', 'persona'], teamMember) ||
    pathOr('', ['metadata', INVITE_TO_PERSONA], teamMember)
  );
};

export const filterMember = (teamMembers: any, advisorType: string) => {
  const hasMatch = (m: any) => equals(getMemberPersona(m), advisorType);
  return filter(hasMatch, teamMembers) || [];
};
export const filterMemberWithAdvisorProfile = (
  teamMembers: any,
  advisorType: string
) => {
  const hasMatch = (m: any) => equals(getMemberPersona(m), advisorType);
  const hasProfile = (m: any) =>
    !isNil(pathOr(null, ['spec', 'advisor_profile'], m));
  const filterMemberWithPersona = filter(hasMatch, teamMembers);
  return filter(hasProfile, filterMemberWithPersona) || [];
};

export const getSmartMatchType = (advisorType: string) => {
  return cond([
    [equals(SMARTMATCH_TYPE_FUNDING_SPECIALIST), always(ADVISOR_FUNDING_SPECIAILIST)],
    [equals(SMARTMATCH_TYPE_BACKEND_OFFICER), always(BACKEND_OFFICER)],
    [equals(SMARTMATCH_TYPE_REALTOR), always(ADVISOR_REALTOR)],
    [equals(SMARTMATCH_TYPE_TAX_ATTORNEY), always(ADVISOR_ATTORNEY)],
    [equals(SMARTMATCH_TYPE_HOME_INSURANCE), always(ADVISOR_INSURANCE)],
    [equals(SMARTMATCH_TYPE_HOME_INSPECTOR), always(ADVISOR_INSPECTOR)],
    [equals(SMARTMATCH_TYPE_LOAN_OFFICER), always(ADVISOR_LOANOFFICER)],
    [equals(SMARTMATCH_TYPE_MOVER), always(ADVISOR_MOVER)],
    [equals(SMARTMATCH_TYPE_COBORROWER), always(COBORROWER)],
    [equals(SMARTMATCH_TYPE_BORROWER), always(BORROWER)],
    [equals(MERCHANT_CASH_ADVANCE), always(BORROWER)],
    [equals(SMARTMATCH_TYPE_APPRAISER), always(APPRAISER)],
    [equals(SMARTMATCH_TYPE_UNDER_WRITER), always(UNDER_WRITER)],
    [equals(SMARTMATCH_TYPE_TITLE_AGENCY), always(TITLE_AGENCY)],
    [equals(SMARTMATCH_TYPE_TAX_ACCOUNTANT), always(ADVISOR_ACCOUNTANT)],
    [equals(SMARTMATCH_TYPE_LOAN_PROCESSOR), always(LOAN_PROCESSOR)],
    [equals(SMARTMATCH_TYPE_LOAN_PROCESSOR_READER), always(LOAN_PROCESSOR_READER)],
    [equals(APPLICANT_DOWNCASE_A), always(APPLICANT)],
    [equals(USER_ONBOARD_ADMIN_LO), always(ADMIN_LOANOFFICER)],
    [equals(USER_ONBOARD_ADMIN_UNDERWRITER), always(ADMIN_UNDER_WRITER)],
    [equals(SMARTMATCH_TYPE_ADMIN_ISO), always(ADVISOR_ADMINISO)],
    [equals(SMARTMATCH_TYPE_ISO), always(ADVISOR_ISO)],
    [equals(SMARTMATCH_TYPE_SALES), always(ADVISOR_SALES)],
    [equals(SMARTMATCH_TYPE_SALES_ADMIN), always(ADVISOR_ADMINSALES)],
    [equals(SMARTMATCH_TYPE_ACCOUNTING), always(ADVISOR_ACCOUNTING)],
    [equals(SMARTMATCH_TYPE_ADMIN), always(ADVISOR_SUPER_ADMIN)],
    [equals(SMARTMATCH_TYPE_HIGH_CREST), always(ADVISOR_HIGH_CEREST)],
    [equals(USER_ONBOARD_LOAN_OFFICER_BACK_END), always(LOAN_OFFICER_BACKEND)],
    [equals(USER_ONBOARD_ADMIN_READER), always(ADVISOR_REVIEWER_ADMIN)],
    [equals(USER_ONBOARD_LOAN_OFFICER_CARDS), always(LOAN_OFFICER_CARDS)],
    [equals(USER_ONBOARD_LOAN_OFFICER_MORTGAGE), always(LOAN_OFFICER_MORTGAGE)],
    [equals(USER_ONBOARD_LOAN_OFFICER_CONSUMER), always(LOAN_OFFICER_CONSUMER)],
    [equals(USER_ONBOARD_ADMIN_PRODUCTS), always(PRODUCT_ADMIN)],
    [equals(USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED), always(LOAN_OFFICER_CARDS_SECURED)],
    [T, always(mkRoleDisplayName(advisorType))],
  ])(toLower(advisorType))
};


/**
 * this method is used to convert the internal role string as user display name
 * @param role { string } role name of the user ex: branch_manager_admin_solar
 * @returns  Capitalized name example Branch Manager (Admin Solar)
 */
const mkRoleDisplayName = (role: string) => {
  const roleName = capitalizeAllWords(replace(/_/g, ' ', role))
  const names = splitAt(2, split(" ", roleName))
  return join(" ", filter(isNotEmpty, flatten(
    [
      returnIsNotEmptyOrTrue(head(names), head(names), []),
      returnIsNotEmptyOrTrue(last(names), [`(${join(" ", nth(1, names) as any)})`], []),
    ]
  ))
  )
}